import { ArboProperty, PropertyV2, ConversionOptions } from "./types"
import { discoverType } from "./discoverers/discoverType"
import { discoverOperation } from "./discoverers/discoverOperation"
import { discoverAttributes } from "./discoverers/discoverAttributes"
import { discoverMedia, discoverThumbnails } from "./discoverers/discoverMedia"
import { discoverTags, discoverKeywords } from "./discoverers/discoverTags"
import { discoverPropertySearch } from "./discoverers/discoverSearch"

export function convertArboToPropertyV2(
  arbo: ArboProperty,
  options: ConversionOptions = {}
): PropertyV2 {
  
  const { type, subtype } = discoverType(arbo)
  const operation = discoverOperation(arbo)
  const attributes = discoverAttributes(arbo, operation, type, subtype, options)
  const media = discoverMedia(arbo)
  const thumbnails = discoverThumbnails(arbo, media)
  
  const tags = options.generateTags !== false 
    ? discoverTags(arbo, attributes, operation)
    : ""
    
  const keywords = options.generateKeywords !== false
    ? discoverKeywords(arbo, attributes)
    : ""

  const title = arbo.titulo || ""
  const description = arbo.descricao || ""
  const reference = arbo.codigo || ""
  
  const price = operation === "sale" 
    ? (arbo.valor_venda || 0)
    : (arbo.valor_aluguel || 0)

  const id = arbo.ref_id
  const now = new Date().toISOString()

  const propertySearch = discoverPropertySearch(
    arbo,
    id,
    title,
    reference,
    type,
    subtype,
    operation,
    price,
    tags,
    keywords,
    description,
    attributes
  )

  const propertyV2: PropertyV2 = {
    id,
    source_id: arbo.ref_id,
    reference,
    title,
    description,
    type,
    subtype,
    operation,
    attributes,
    media,
    tags,
    keywords,
    thumbnails: options.defaultThumbnail || thumbnails,
    web_code: null,
    provider: "arbo-crm",
    index: null,
    seo: null,
    visibility: null,
    preview: null,
    created_at: arbo.created_at || now,
    modified_at: arbo.updated_at || now,
    updated_at: now,
    property_search: [propertySearch]
  }

  return propertyV2
}

export function convertMultipleArboToPropertyV2(
  arboProperties: ArboProperty[],
  options: ConversionOptions = {}
): PropertyV2[] {
  return arboProperties.map(arbo => convertArboToPropertyV2(arbo, options))
}